
const setTheme = ({ commit }, theme) => {
  commit('SET_THEME', theme)
}

const setDevice = ({ commit }, device) => {
  commit('SET_DEVICE', device)
}
export default {
  setTheme,
  setDevice
}



// WEBPACK FOOTER //
// ./src/store/modules/app/actions.js